import { Box, BoxProps } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import {
  SimulationBehaviorCash,
  useAssetClassesSimulationBehaviorCashListQuery,
  useAssetClassesSimulationBehaviorCashUpdateMutation,
} from "@app/api/carApi.generated";
import { CarNumberFieldDelayed } from "@app/components/NumberField";
import { CarTextFieldDelayed } from "@app/components/Inputs";
import { CarKatexCalcField } from "@app/components/Katex";

interface SimulationModelsBehaviorCashProps {
  assetClassId: string;
  sx?: BoxProps["sx"];
}

export const SimulationModelsBehaviorCash = (
  props: SimulationModelsBehaviorCashProps,
) => {
  const data = useAssetClassesSimulationBehaviorCashListQuery({
    id: "",
  });

  const [updateMut] = useAssetClassesSimulationBehaviorCashUpdateMutation();

  const item = data.data?.at(0);

  const updateItem = (value: SimulationBehaviorCash) => {
    updateMut({
      id: value.id ?? "",
      simulationBehaviorCash: value,
    });
  };

  return (
    <Box sx={{ ...props.sx, display: "flex", flexDirection: "column" }}>
      <TablePlaceHolder isLoading={data.isLoading} rows={8}>
        {item && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "180px 180px",
              columnGap: 11,
              rowGap: 5,
              ".MuiInputBase-root": {
                backgroundColor: "white",
              },
            }}
          >
            <CarKatexCalcField
              label="Model Equation"
              value={item.regression_result?.equation_katex}
            />
            <div />
            <CarNumberFieldDelayed
              label="Model Slope Override"
              decimalPlaces={10}
              value={item.model_slope_override}
              onChange={(model_slope_override) =>
                updateItem({
                  ...item,
                  model_slope_override: model_slope_override ?? 0,
                })
              }
            />
            <CarNumberFieldDelayed
              label="Absolute Upper Boundary"
              decimalPlaces={3}
              value={item.absolute_upper_boundary}
              onChange={(absolute_upper_boundary) =>
                updateItem({
                  ...item,
                  absolute_upper_boundary: absolute_upper_boundary ?? 0,
                })
              }
            />
            <CarTextFieldDelayed
              label="Model Slope Override Rational"
              sx={{ gridColumn: "1 / span 2" }}
              fullWidth
              multiline
              rows={5}
              value={item.model_slope_override_rationale}
              onChange={(model_slope_override_rationale) =>
                updateItem({
                  ...item,
                  model_slope_override_rationale:
                    model_slope_override_rationale,
                })
              }
            />
            <CarNumberFieldDelayed
              label="Max. Step"
              decimalPlaces={1}
              value={item.max_step}
              onChange={(max_step) =>
                updateItem({
                  ...item,
                  max_step: max_step ?? 0,
                })
              }
            />
            <CarNumberFieldDelayed
              label="Min. Yield"
              decimalPlaces={4}
              value={item.min_yield}
              onChange={(min_yield) =>
                updateItem({ ...item, min_yield: min_yield ?? 0 })
              }
            />
            <CarNumberFieldDelayed
              label="Sigma"
              decimalPlaces={16}
              value={item.sigma}
              onChange={(sigma) => updateItem({ ...item, sigma: sigma ?? 0 })}
            />
            <CarNumberFieldDelayed
              label="Crisis Mode Returns"
              decimalPlaces={2}
              maxValue={1}
              minValue={-1}
              value={item.crisis_mode_returns}
              onChange={(crisis_mode_returns) =>
                updateItem({ ...item, crisis_mode_returns })
              }
            />
            <CarNumberFieldDelayed
              label="Static Model Calculated Mu"
              decimalPlaces={10}
              value={item.static_model_calculated_mu}
              onChange={(static_model_calculated_mu) =>
                updateItem({
                  ...item,
                  static_model_calculated_mu: static_model_calculated_mu ?? 0,
                })
              }
            />
            <div />
            <CarNumberFieldDelayed
              label="Static Model Mu Override"
              decimalPlaces={10}
              value={item.static_model_mu_override}
              onChange={(static_model_mu_override) =>
                updateItem({
                  ...item,
                  static_model_mu_override: static_model_mu_override ?? 0,
                })
              }
            />
            <CarTextFieldDelayed
              label="Static Model Mu Override Rationale"
              sx={{ gridColumn: "1 / span 2" }}
              fullWidth
              multiline
              rows={5}
              value={item.static_model_mu_override_rationale}
              onChange={(static_model_mu_override_rationale) =>
                updateItem({
                  ...item,
                  static_model_mu_override_rationale,
                })
              }
            />
          </Box>
        )}
      </TablePlaceHolder>
    </Box>
  );
};
